import {
  FETCHING_ALL_ORDERS,
  FETCHING_ORDER,
  ALL_ORDERS_FETCHED,
  ORDER_FETCHED,
  ORDER_PAYTYPE_FETCHED,
  ORDER_STATUS_FETCHED,
  FETCHING_ORDER_PAYTYPE,
  FETCHING_ORDER_STATUES,
  UPDATING_ORDER_STATUS,
  ORDER_STATUS_UPDATED,
} from '../Constants/types'

const initialState = {
  allOrders: [],
  singleOrder: {},
  isAllOrdersLoading: false,
  isOrderLoading: false,
  page: 0,
  total_count: 0,
  orderStatusArr: [],
  orderPaytypeArr: [],
  isOrderStatusLoading: false,
  isOrderPaytypeLoading: false,
  isAllOrdersEmpty: false,
  isOrderStatusUpdating: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCHING_ALL_ORDERS:
      return {
        ...state,
        isAllOrdersLoading: true,
      }
    case ALL_ORDERS_FETCHED:
      console.log(action.payload)
      if (action.payload.result.length && action.payload.page > 0) {
        return {
          ...state,
          isAllOrdersLoading: false,
          allOrders: [...state.allOrders, ...action.payload.result],
          page: action.payload.page,
        }
      } else if (action.payload.page == 0) {
        return {
          ...state,
          isAllOrdersLoading: false,
          allOrders: action.payload.result,
          page: action.payload.page,
          total_count: action.payload.total_count,
          isAllOrdersEmpty: action.payload.total_count ? false : true,
        }
      } else {
        return {
          ...state,
          isAllOrdersLoading: false,
          allOrders: state.allOrders,
          page: state.page,
        }
      }
    case FETCHING_ORDER:
      return {
        ...state,
        isOrderLoading: true,
      }
    case ORDER_FETCHED:
      return {
        ...state,
        isOrderLoading: false,
        singleOrder: action.payload,
      }

    case FETCHING_ORDER_PAYTYPE:
      return {
        ...state,
        isOrderPaytypeLoading: action.payload,
      }
    case ORDER_PAYTYPE_FETCHED:
      return {
        ...state,
        isOrderPaytypeLoading: false,
        orderPaytypeArr: action.payload,
      }
    case FETCHING_ORDER_STATUES:
      return {
        ...state,
        isOrderStatusLoading: action.payload,
      }
    case ORDER_STATUS_FETCHED:
      return {
        ...state,
        isOrderStatusLoading: false,
        orderStatusArr: action.payload,
      }
    case UPDATING_ORDER_STATUS:
      return {
        ...state,
        isOrderStatusUpdating: action.payload,
      }

    case UPDATING_ORDER_STATUS:
      return {
        ...state,
        isOrderStatusUpdating: false,
      }
    default:
      return state
  }
}
